export default __webpack_public_path__ + "static/media/31_desktop.719d2273.jpg";